import React from 'react'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { filterByType } from '../features/filter/filterSlice'

export default function Sidebar() {
    const dispatch = useDispatch()

    function filterJobsByType(type) {
        dispatch(filterByType(type))
    }

    return (
        <div className="sidebar">
            <nav>
                <ul className="space-y-4">
                    <li>
                        <Link to="/" onClick={() => filterJobsByType("")} className="main-menu menu-active" id="lws-alljobs-menu">
                            <i className="fa-solid fa-briefcase"></i>{" "}
                            <span> All Available Jobs</span>
                        </Link>
                        <ul className="space-y-6 lg:space-y-2 ">
                            <li>
                                <button className="sub-menu" onClick={() => filterJobsByType("internship")} id="lws-internship-menu">
                                    <i className="fa-solid fa-stop" style={{ color: "#FF5757" }}></i>{" "}
                                    Internship
                                </button>
                            </li>
                            <li>
                                <button className="sub-menu" onClick={() => filterJobsByType("full time")} id="lws-fulltime-menu">
                                    <i className="fa-solid fa-stop" style={{ color: "#FF8A00" }}></i>{" "}
                                    Full Time
                                </button>
                            </li>
                            <li>
                                <button className="sub-menu" onClick={() => filterJobsByType("remote")} id="lws-remote-menu">
                                    <i className="fa-solid fa-stop" style={{ color: "#56E5C4" }}></i>{" "}
                                    Remote
                                </button>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <Link to="/add-job" className="main-menu" id="lws-addJob-menu">
                            <i className="fa-solid fa-file-circle-plus"></i>{" "}
                            <span>Add NewJob</span>
                        </Link>
                    </li>
                </ul>
            </nav>
        </div>
    )
}
